export const setLoaded = () => {
  return {
    type: 'SET_LOADED',
  };
}
